import lineApi from '@/api/line.api'

export const lineService = (function () {
  'use strict'


  /**
   * Devuelve los datos para la tabla del ABM de Línea
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} headers
   */
  async function findAll(pageSize, pageNumber, headers = false) {
    try {
      /*
      if (pageSize > 0 && pageNumber > 0) {
        const response = await lineApi.findAll(pageSize, pageNumber, headers)
        return response.data
      } else {
        return {
          data: [],
          headers: []
        }
      }
      */
      const response = await lineApi.findAll(undefined, undefined, headers)
      return response.data
    } catch (exception) {
      console.log(exception)
      return {
        data: [],
        headers: []
      }
    }
  }

  /**
   * Devuelve un arreglo con las líneas no asignadas
   */
  async function findAllNonAssigned() {
    try {
      const response = await lineApi.findAllNonAssigned()
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve el total de line de la collection para el paginador de la tabla del ABM
   */
  async function getTotal() {
    try {
      const response = await lineApi.getTotal()
      return response.data
    } catch (exception) {
      console.log(exception)
      return 0
    }
  }

  /**
   * Estados posibles para una línea
   */
  async function getStates() {
    try {
      const response = await lineApi.getStates()
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Marcas de líneas
   */
  async function getCarriers() {
    try {
      const response = await lineApi.getCarriers()
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve una línea con el id enviado como parámetro
   * @param {*} lineId
   */
  async function getLine(lineId) {
    try {
        const response = await lineApi.getLine(lineId)
        return response.data
    } catch (exception) {
        console.log(exception)
        return false
    }
  }

  /**
   * Para validar el número de línea
   * Devuelve true si ya está asignado a una línea
   * @param {*} lineNumber
   */
  async function validateLineNumber(lineNumber) {
    try {
      if (lineNumber) {
        const response = await lineApi.validateLineNumber(lineNumber)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
        console.log(exception)
        return false
    }
  }

  /**
   * Para validar el número de sim card
   * Devuelve true si ya está asignado a una línea
   * @param {*} simCardNumber
   */
  async function validateSimCardNumber(simCardNumber) {
    try {
        const response = await lineApi.validateSimCardNumber(simCardNumber)
        return response.data
    } catch (exception) {
        console.log(exception)
        return false
    }
  }

  /**
   * Para eliminar un line
   */
  async function deleteOne(id) {
    /*
    try {
        const response = await lineApi.deleteOne(id)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await lineApi.deleteOne(id)
    return response.data
  }

  /**
   * Para eliminación múltiple
   */
  async function deleteMany(ids) {
    /*
    try {
        const response = await lineApi.deleteMany(ids)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await lineApi.deleteMany(ids)
    return response.data
  }


  /**
   * Crea una nueva cosa en la collection
   * @param {*} line
   */
  async function create(line) {
    /*
    try {
      const response = await lineApi.create(line)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await lineApi.create(line)
    return response.data
  }

  /**
   * Actualiza una cosa existente en la collection
   * @param {*} line
   */
  async function update(line) {
    /*
    try {
      const response = await lineApi.update(line)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await lineApi.update(line)
    return response.data
  }

  return {
    findAll,
    getTotal,
    findAllNonAssigned,
    getStates,
    getCarriers,
    getLine,
    validateLineNumber,
    validateSimCardNumber,
    deleteOne,
    deleteMany,
    create,
    update
  }
})()
